import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-impresion',
  templateUrl: './impresion.component.html',
  styleUrl: './impresion.component.scss'
})
export class ImpresionComponent{
      

  FUENTE_PEQUENA = new Uint8Array([0x1B, 0x21, 0x04]); 

  RESETEAR_IMPRESORA = new Uint8Array([0x1B, 0x40]);

  CORTAR_PAPEL = new Uint8Array([0x1D, 0x56, 0x00]); // Comando de corte de papel

  
}
